<template>
    <header
        :class="[
            'main-header pt-3',
            {
                'dark-mode': isDarkMode,
                'is-customer-account': isCustomerAccount,
            },
        ]"
    >
        <div
            :class="['container-fluid', { container: isGuest || !isLoggedIn }]"
        >
            <nav class="navbar navbar-expand-xl">
                <div
                    class="navbar-brand d-flex align-items-center"
                    role="button"
                    @click="toggleLogo()"
                >
                    <img :src="logoOnlySrc" alt="Logo" class="logo me-2" />
                    <span> TENNY ENTERPRISES, INC.</span>
                </div>
                <button
                    class="navbar-toggler border-0 text-success"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#mainNavbar"
                >
                    <font-awesome-icon icon="bars" />
                </button>
                <div
                    class="collapse navbar-collapse justify-content-end"
                    id="mainNavbar"
                >
                    <ul
                        class="navbar-nav ms-l-2 me-md-4 gap-md-2"
                        v-if="!isLoggedIn || isGuest"
                    >
                        <li
                            v-for="link in links"
                            :key="link.name"
                            class="nav-item"
                            :class="{ dropdown: link.type === 'dropdown' }"
                            @mouseenter="
                                link.type === 'dropdown' &&
                                    (dropdownOpen = true)
                            "
                            @click="navigateTo(link)"
                        >
                            <router-link
                                :to="link.path"
                                class="nav-link d-flex align-items-center"
                                :data-bs-toggle="
                                    link.type === 'dropdown' ? 'dropdown' : null
                                "
                                @click="isLeftMenuOpen = false"
                            >
                                <span
                                    class="text-nowrap me-1 text-dark navlink-label"
                                    >{{ link.name }}</span
                                >
                                <font-awesome-icon
                                    v-if="link.type === 'dropdown'"
                                    icon="chevron-down"
                                    class="ms-1 transition-transform"
                                    :class="{ 'rotate-up': dropdownOpen }"
                                />
                            </router-link>
                            <ul
                                v-if="link.type === 'dropdown' && dropdownOpen"
                                class="dropdown-menu show"
                                ref="pCategories"
                            >
                                <h6
                                    class="px-3 pt-3 fw-semibold"
                                    style="font-size: 15px"
                                >
                                    Product Categories
                                </h6>
                                <li
                                    v-for="sublink in link.options.slice(0, 10)"
                                    :key="sublink.key"
                                    class="dropdown-item p-3"
                                    @click="filterProductsByCategories(sublink)"
                                >
                                    {{ sublink.name }}
                                </li>
                                <li class="mx-1">
                                    <button
                                        class="btn w-100 text-start text-muted see-all-categories-button"
                                        @click="
                                            dropdownOpen = false;
                                            $router.push('/shop-products');
                                        "
                                    >
                                        See all categories
                                        <font-awesome-icon
                                            icon="arrow-right"
                                            size="sm"
                                            class="ms-1 arrow-right"
                                        />
                                    </button>
                                </li>
                                <hr />
                                <li
                                    class="dropdown-item p-3 mb-3"
                                    @click="
                                        dropdownOpen = false;
                                        $router.push(
                                            isLoggedIn
                                                ? '/product-request'
                                                : '/login',
                                        );
                                    "
                                >
                                    Related product request
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <div
                        class="d-flex gap-2 mt-2 mt-md-0 align-items-center ms-md-3"
                        v-if="!isLoggedIn"
                    >
                        <button
                            class="btn login-button"
                            @click="$router.push('/login')"
                        >
                            Login
                        </button>
                        <!-- <span class="small fw-bold">or</span> -->
                        <button
                            href="#"
                            class="btn register-button text-nowrap"
                            @click="$router.push('/register')"
                        >
                            Register as Guest
                        </button>
                    </div>
                    <div
                        class="ms-5 me-2 loggedIn"
                        v-if="isLoggedIn && loggedUser"
                    >
                        <ul
                            class="navbar-nav d-flex align-items-center flex-row gap-3"
                        >
                            <li
                                class="nav-item dropdown position-relative"
                                @click.stop
                            >
                                <div
                                    class="d-flex align-items-center"
                                    role="button"
                                    @click="toggleUserMenu"
                                    @mouseenter="isUserMenu = true"
                                >
                                    <font-awesome-icon
                                        icon="circle-user"
                                        class="me-1 fs-4"
                                    />
                                    <span class="user text-nowrap pe-3">{{
                                        loggedUser?.first_name +
                                        " " +
                                        loggedUser?.last_name
                                    }}</span>
                                </div>
                                <div
                                    ref="userMenu"
                                    v-if="isUserMenu"
                                    class="dropdown-menu show mt-2"
                                    @mouseleave="toggleUserMenu"
                                >
                                    <button
                                        class="dropdown-item p-3 mb-1 d-flex align-items-center"
                                        @click="toggleUserMenu('/my-account')"
                                    >
                                        <font-awesome-icon
                                            icon="fa-solid fa-id-badge"
                                            class="me-2"
                                        />
                                        My Account
                                    </button>
                                    <button
                                        v-if="isGuest"
                                        class="dropdown-item p-3 mb-1 d-flex align-items-center"
                                        @click="toggleUserMenu('/orders')"
                                    >
                                        <font-awesome-icon
                                            icon="fa-solid fa-list"
                                            class="me-2"
                                        />
                                        My Purchases
                                    </button>
                                    <button
                                        class="dropdown-item p-3 mb-1 d-flex align-items-center"
                                        @click="
                                            toggleUserMenu(
                                                '/my-product-requests',
                                            )
                                        "
                                    >
                                        <font-awesome-icon
                                            icon="bullhorn"
                                            class="me-2"
                                        />
                                        My Product Requests
                                    </button>
                                    <button
                                        class="dropdown-item p-3 mb-2 d-flex align-items-center"
                                        @click="logout"
                                    >
                                        <font-awesome-icon
                                            icon="fa-solid fa-power-off"
                                            class="me-2"
                                        />
                                        Logout
                                    </button>
                                </div>
                            </li>
                            <!-- Notification Bell -->
                            <li @click="showNotificationList">
                                <div
                                    class="cart-icon-wrapper d-flex align-items-center"
                                    role="button"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-bell"
                                        class="fs-5"
                                    />
                                    <span class="no-of-items">{{
                                        noOfNotifications
                                    }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    </header>
</template>

<script src="./HeaderScript.vue" />
